if ( document.getElementById('vip-client-form') ) {
    let clientForm  = document.getElementById('vip-client-form');
    let form        = clientForm.querySelector('form');

    const phoneInputField = document.querySelector("#vip_phone");
    let phoneNumber = window.intlTelInput(phoneInputField, {
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.2.16/build/js/utils.js",
        showFlags: true,
        showSelectedDialCode: true,
        preferredCountries: ['us', 'ca', 'uk'],
        initialCountry: 'us',
        autoInsertDialCode: true
    });


    form.addEventListener('submit', function(e) {
        e.preventDefault();
        let vipPhone = form.querySelector('input[name="vip_phone"]');
        let vipEmail = form.querySelector('input[name="vip_email"]');
        let errorsDiv = document.querySelector('.vip__form--errors');
        let showErrors = false;

        if ( vipPhone.value === '' || vipPhone.value.length < 5 ) {
            showErrors = true;
        }

        if ( vipEmail.value === '' || vipEmail.value.length < 5 ) {
            showErrors = true;
        }

        if (showErrors) {
            errorsDiv.classList.add('visible');
            errorsDiv.textContent = 'Please enter valid values';
            setTimeout(function() {
                errorsDiv.classList.remove('visible');
            }, 2000);
            return;
        }

        let fullNumber = phoneNumber.getNumber();

        // Send the information to Post Script
        fetch('https://worldaxethrowingleague.com/wp-json/v1/vip/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                customer_phone: fullNumber,
                customer_email: vipEmail.value
            })
        })
        .then(resp => resp.json())
        .then(function(data) {
            vipEmail.value      = '';
            phoneNumber.setNumber('');

            errorsDiv.classList.add('visible', 'success');
            errorsDiv.textContent = 'Information added successfully';
            setTimeout(function() {
                errorsDiv.classList.remove('success');
                errorsDiv.classList.remove('visible');
            }, 2000);
        });

    });

}